import { FeatureFlag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';

import { EventTypeId } from '@swf/sports/types/eventType';

const useIsEventTypeLiveDataEnabled = (eventTypeId: EventTypeId) => {
  const isLiveDataEnabled = useFeature(FeatureFlag.ISPEnableLiveData);
  const isLiveAmericanFootballDataEnabled = useFeature(
    FeatureFlag.ISPEnableLiveAmericanFootballData
  );
  const isLiveBaseballDataEnabled = useFeature(FeatureFlag.ISPEnableLiveBaseballData);
  const isLiveBasketballDataEnabled = useFeature(FeatureFlag.ISPEnableLiveBasketballData);
  const isLiveDartsDataEnabled = useFeature(FeatureFlag.ISPEnableLiveDartsData);
  const isLiveESportsDataEnabled = useFeature(FeatureFlag.ISPEnableLiveESportsData);
  const isLiveFootballDataEnabled = useFeature(FeatureFlag.ISPEnableLiveFootballData);
  const isLiveIceHockeyDataEnabled = useFeature(FeatureFlag.ISPEnableLiveIceHockeyData);
  const isLiveTableTennisDataEnabled = useFeature(FeatureFlag.ISPEnableLiveTableTennisData);
  const isLiveTennisDataEnabled = useFeature(FeatureFlag.ISPEnableLiveTennisData);

  if (!isLiveDataEnabled) return false;
  switch (eventTypeId) {
    case EventTypeId.AMERICAN_FOOTBALL:
      return isLiveAmericanFootballDataEnabled;
    case EventTypeId.BASEBALL:
      return isLiveBaseballDataEnabled;
    case EventTypeId.BASKETBALL:
      return isLiveBasketballDataEnabled;
    case EventTypeId.DARTS:
      return isLiveDartsDataEnabled;
    case EventTypeId.E_SPORTS:
      return isLiveESportsDataEnabled;
    case EventTypeId.ICE_HOCKEY:
      return isLiveIceHockeyDataEnabled;
    case EventTypeId.SOCCER:
      return isLiveFootballDataEnabled;
    case EventTypeId.TABLE_TENNIS:
      return isLiveTableTennisDataEnabled;
    case EventTypeId.TENNIS:
      return isLiveTennisDataEnabled;
    default:
      return false;
  }
};

export default useIsEventTypeLiveDataEnabled;
